import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { BRAND } from '../data/mock';

const WhatsAppFloat = () => {
  const [tip, setTip] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setTip(false), 6000);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="fixed bottom-6 right-6 z-40 flex items-end gap-3">
      {tip && (
        <div className="hidden sm:flex relative max-w-[220px] bg-brand-cream text-brand-ink p-3 pr-8 text-[12px] leading-snug shadow-xl rounded-sm">
          <button onClick={() => setTip(false)} className="absolute top-1.5 right-1.5 text-brand-ink/60 hover:text-brand-ink">
            <X size={12} />
          </button>
          Hızlı teklif için <strong className="font-semibold">WhatsApp</strong>'tan yazın — 5 dakikada dönüş.
        </div>
      )}
      <a
        href={BRAND.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="h-14 w-14 grid place-items-center bg-[#25D366] hover:bg-[#1ebe5d] rounded-full shadow-2xl shadow-[#4A151A]/40 transition-colors"
        aria-label="WhatsApp"
      >
        <MessageCircle size={26} className="text-white" />
      </a>
    </div>
  );
};

export default WhatsAppFloat;
